import { useState, useRef } from 'react';

export const useToggle: any = (defaultState = false) => {
  const [isToggledOn, setToggle] = useState<boolean>(defaultState);
  const doToggle = useRef(() => setToggle((curr) => !curr));
  return [isToggledOn, setToggle, doToggle?.current];
};

export default useToggle;
